
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-information/[slug]",
      function () {
        return require("private-next-pages/product-information/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-information/[slug]"])
      });
    }
  